module.exports = __webpack_public_path__ + "img/物体语义.19fc0a80.svg";